export default "__VITE_ASSET__s$6Y9jQJ__"